import { Anchor, Blockquote, Divider, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../../stores/LanguageStore";

const TrialElementError = ({ subscriptions, pop }) => {
  const lang = useLanguage(s => s.language)

  return (
    subscriptions?.last_payment_error_details && (
      <>
        <Blockquote color="red" p={"md"} fw={500} radius={pop ? "md" : "lg"}>
          <Text size={pop ? "md" : "lg"}>
            <b>{lang.pricing.failed_title}</b>
            <br />
            {lang.pricing.failed_text}
            <Anchor component={Link} to={"/settings/subscription/billing"}>
             {" "} {lang.pricing.verify}
            </Anchor>
          </Text>

          <Text size={pop ? "md" : "lg"} style={{fontStyle: "italic"}} mt={8} c={"dimmed"}>
            {subscriptions?.last_payment_error_details?.message}
          </Text>
        </Blockquote>

        {!pop && <Divider my={24} />}
      </>
    )
  );
};

export default TrialElementError;
